<template>
  <section>
    <div class="table_top_div" style="padding-top: 0">
      <el-tabs style="width: 100%; font-size: 12px" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="日耗用量整体分析" name="1">
          <el-row style="margin-top: 10px" :type="isMobile ? '' : 'flex'" justify="space-around">
            <el-col :span="5" :xs="24">
              <el-card style="background-color: #a992e2; position: relative" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#eee', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary.ytdTargetVolume) }}
                </div>
                <i
                  class="fa fa-bar-chart-o"
                  style="position: absolute; font-size: 80px; bottom: -30px; right: -10px; color: #e7f5fa; opacity: 0.7"
                ></i>
                <div :style="{ color: '#eee', 'font-size': isMobile ? '14px' : '' }">YTD 指标片数</div>
              </el-card>
            </el-col>
            <el-col :span="5" :xs="24">
              <el-card style="background-color: #55badf; position: relative" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#eee', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary.ytdActualVolume) }}
                </div>
                <i
                  class="fa fa-bar-chart-o"
                  style="position: absolute; font-size: 80px; bottom: -30px; right: -10px; color: #e7f5fa; opacity: 0.7"
                ></i>
                <div :style="{ color: '#eee', 'font-size': isMobile ? '14px' : '' }">YTD 日耗用量片数</div>
              </el-card>
            </el-col>
            <el-col :span="5" :xs="24">
              <el-card style="background-color: #ec6f5a; position: relative" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#eee', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary.ytdAchievementRate * 100).toFixed(0) + '%' }}
                </div>
                <i class="fa fa-percent" style="position: absolute; font-size: 70px; bottom: -20px; right: -0px; color: #e7f5fa; opacity: 0.7"></i>
                <div :style="{ color: '#eee', 'font-size': isMobile ? '14px' : '' }">YTD 日耗用量达成</div>
              </el-card>
            </el-col>
            <el-col :span="5" :xs="24">
              <el-card style="background-color: #f7c65f; position: relative" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#eee', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary.ytdGrowthRate * 100).toFixed(0) + '%' }}
                </div>
                <i class="fa fa-percent" style="position: absolute; font-size: 70px; bottom: -20px; right: -0px; color: #e7f5fa; opacity: 0.7"></i>
                <div :style="{ color: '#eee', 'font-size': isMobile ? '14px' : '' }">YTD 日耗用量增长</div>
              </el-card>
            </el-col>
          </el-row>
          <reprot_forms
            :area_list="area_list"
            :product_List="product_List"
            v-if="activeName == '1'"
            :activeName="activeName"
            @getReportData="getReportData"
          ></reprot_forms>
          <el-row>
            <el-col :span="12" :xs="24"><div ref="chartContainer" style="width: 100%; height: 300px; margin: 10px 0"></div></el-col>
            <el-col :span="12" :xs="24"><div ref="chartContainer2" style="width: 100%; height: 300px; margin: 10px 0"></div></el-col>
            <el-col :span="12" :xs="24"><div ref="chartContainer3" style="width: 100%; height: 300px"></div></el-col>
            <el-col :span="12" :xs="24"><div ref="chartContainer4" style="width: 100%; height: 300px"></div></el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="日耗用量月度分析" name="2">
          <el-row style="margin-top: 10px" :type="isMobile ? '' : 'flex'" :gutter="5" justify="space-around">
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary_mtd.mtdTargetVolume) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 指标片数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary_mtd.mtdActualVolume) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 日耗用量片数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_mtd.mtdAchievementRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 日耗用量达成</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_mtd.mtdGrowthRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 日耗用量增长</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary_mtd.mtdDailyPeopleCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 日均填报人数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_mtd.mtdDailyFillRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 日均填报率</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_mtd.mtdTimeProgress * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 时间进度</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_mtd.mtdTargetProgress * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">MTD 指标完成进度</div>
              </el-card>
            </el-col>
          </el-row>
          <reprot_forms
            :area_list="area_list"
            :product_List="product_List"
            v-if="activeName == '2'"
            :activeName="activeName"
            @getReportData="getReportData"
          ></reprot_forms>
          <el-row>
            <el-col :span="12" :xs="24"><div ref="chartContainer_mtd" style="width: 100%; height: 300px"></div></el-col>
            <el-col :span="12" :xs="24"><div ref="chartContainer2_mtd" style="width: 100%; height: 300px"></div></el-col>
            <el-col :span="24" :xs="24"><div ref="chartContainer3_mtd" style="width: 100%; height: 300px"></div></el-col>
            <!-- <el-col :span="12"><div ref="chartContainer4" style="width: 100%; height: 300px"></div></el-col> -->
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="日耗用量每日分析" name="3">
          <el-row style="margin-top: 10px" :type="isMobile ? '' : 'flex'" :gutter="5" justify="space-around">
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary_day.dailyTargetCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">当日指标片数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary_day.dailyUsageCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">当日耗用量片数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_day.dailyAchievementRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">当日耗用量达成</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ currency(summary_day.dailyReporterCount) }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">当日填报人数</div>
              </el-card>
            </el-col>
            <el-col :span="4" :xs="24">
              <el-card style="background-color: #024c6f" :class="isMobile ? 'card_cls card_cls_mb' : 'card_cls'" shadow="hover">
                <div :style="{ color: '#def3fd', 'margin-bottom': '5px', 'font-size': isMobile ? '18px' : '24px' }">
                  {{ Number(summary_day.dailyFillRate * 100).toFixed(0) + '%' }}
                </div>
                <div :style="{ color: '#def3fd', 'font-size': isMobile ? '14px' : '' }">当日填报率</div>
              </el-card>
            </el-col>
          </el-row>
          <reprot_forms
            :area_list="area_list"
            :product_List="product_List"
            v-if="activeName == '3'"
            :activeName="activeName"
            @getReportData="getReportData"
          ></reprot_forms>
          <el-row>
            <el-col :span="12" :xs="24"><div ref="chartContainer_day" style="width: 100%; height: 300px"></div></el-col>
            <el-col :span="12" :xs="24"><div ref="chartContainer2_day" style="width: 100%; height: 300px"></div></el-col>
            <el-col v-show="!roleName_list.includes('小区经理') && !roleName_list.includes('大区经理')" :span="24" :xs="24">
              <div ref="chartContainer3_day" style="width: 100%; height: 300px"></div>
            </el-col>
            <!-- <el-col :span="24"> -->
            <el-table
              border
              v-show="!roleName_list.includes('小区经理') && !roleName_list.includes('大区经理')"
              width="100%"
              :show-header="false"
              :data="subRegionPerformance_list"
              class="reports"
              header-cell-class-name="header_cell_name"
              :cell-style="{ 'text-align': 'center' }"
              highlight-current-row
              style="white-space: inherit"
            >
              <el-table-column
                :min-width="isMobile ? '50' : '10%'"
                v-for="(item, index) in subRegionPerformance_getIHeaders"
                :key="index"
                :prop="item"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row[item] }}
                </template>
              </el-table-column>
            </el-table>
            <p
              v-if="isMobile && !roleName_list.includes('小区经理') && !roleName_list.includes('大区经理')"
              style="color: red; padding: 0; margin: 0"
            >
              &lt&lt&lt向左滑动查看更多
            </p>
            <!-- </el-col> -->
            <!-- <el-col :span="12"><div ref="chartContainer4" style="width: 100%; height: 300px"></div></el-col> -->
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </section>
</template>

<script>
import { calculateSum, loadings } from '@/utils'
import {
  usagereport_getytdusage_ytd,
  usagereport_getregionsbylevel,
  usagereport_getytdusage_mtd,
  usagereport_getdailyusage_day,
  system_getproductlistothers,
  extapi_dashboard_get,
} from '@/api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'
import * as echarts from 'echarts'
import reprot_forms from './data_report_new_queryForms'
export default {
  components: { Toolbar, quillEditor, reprot_forms },
  computed: {
    style_tbs() {
      return {
        width: this.isMobile ? '1200px' : '100%',
        height: '400px',
        display: 'inline-block',
      }
    },
    style_tbs2() {
      return {
        width: this.isMobile ? '800px' : '100%',
        height: '400px',
        display: 'inline-block',
      }
    },
  },
  data() {
    return {
      color_list: ['#a992e2', '#55badf', '#ec6f5a', '#f7c65f', '#37bc9b', '#5661e8', '#db56e8'],
      color_list2: ['#f7c65f', '#5661e8', '#ec6f5a', '#a992e2', '#37bc9b', '#55badf', '#db56e8'],
      //   color_list: ['#ec6f5a', '#f7c65f', '#a992e2', '#55badf', '#37bc9b', '#5661e8', '#db56e8'],
      subRegionPerformance_getIHeaders: [],
      subRegionPerformance_list: [],
      charts_list: [],
      roleName_list: [],
      filters: {
        StartMonth: '',
        EndMonth: '',
      },
      filters_mtd: {
        Month: '',
      },
      filters_day: {
        Date: '',
      },
      city_list: [],
      area_list: [],
      isMobile: false,
      summary: {},
      summary_mtd: {},
      summary_day: {},
      ytd_list: [],
      activeName: '1',
      product_List: '',
    }
  },
  methods: {
    async extapi_dashboard_get_fn() {
      const {
        data: { data },
      } = await extapi_dashboard_get()
      let new_obj = {}
      let roleName_list = []
      for (var i in data) {
        roleName_list.push(data[i].roleName)
        new_obj = {
          ...data[i].flacsSummarys,
          ...data[i].managerSummary,
          ...data[i].salesSummary,
        }
      }
      this.roleName_list = roleName_list
      this.new_obj = new_obj
    },
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionId === value)
      this.city_list = selectedOptions[0].subRegions
      this.filters.city = ''
    },
    async dashboard_getregionsbylevel() {
      const { data } = await usagereport_getregionsbylevel()
      this.area_list = data.data.regions
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },

    async usagereport_getytdusage_ytd_fn() {
      loadings()
      const { data } = await usagereport_getytdusage_ytd(this.filters)
      this.summary = data.summary
      this.initChart(data)
      this.initChart2(data)
      this.initChart3(data)
      this.initChart4(data)
      loadings(0)
    },
    async usagereport_getytdusage_mtd_fn() {
      loadings()
      const { data } = await usagereport_getytdusage_mtd(this.filters_mtd)
      this.summary_mtd = data.summary
      this.initChart_mtd(data)
      this.initChart_mtd2(data)
      this.initChart_mtd3(data)
      loadings(0)
    },
    // getIHeaders(){

    // },
    async usagereport_getdailyusage_day_fn() {
      loadings()
      const { data } = await usagereport_getdailyusage_day(this.filters_day)
      this.summary_day = data.summary
      let datasa = data.subRegionPerformance
      const iHeaders = [
        {
          prop: 'subRegionName',
          label: '',
        },
        {
          prop: 'target',
          label: '指标',
        },
        {
          prop: 'dailyUsage',
          label: '日耗用量',
        },
        {
          prop: 'achievementRate',
          label: '达成率',
        },
      ]
      const getIHeaders = datasa.subRegionPerformance.reduce((pre, cur, index) => pre.concat(`value${index}`), ['title'])

      const getIValues = iHeaders.map((item) => {
        return datasa.subRegionPerformance.reduce(
          (pre, cur, index) =>
            Object.assign(pre, { ['value' + index]: item.prop == 'achievementRate' ? (cur[item.prop] * 100).toFixed(0) + '%' : cur[item.prop] }),
          {
            title: item.label,
          }
        )
      })
      this.subRegionPerformance_list = getIValues
      this.subRegionPerformance_getIHeaders = getIHeaders
      this.initChart_day(data)
      this.initChart_day2(data)
      this.initChart_day3(data)
      loadings(0)
    },
    initChart_day(res) {
      var res = res.regionPerformance
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer_day)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '达成率']
      const regions = res.regionPerformance.map((item) => item.regionName)
      //   今年
      const thisYearData = res.regionPerformance.map((item) => item.thisYear)
      //   去年
      const dailyUsage = res.regionPerformance.map((item) => item.dailyUsage)
      //   指标
      const target = res.regionPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.regionPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.regionPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      let by_region = ''
      //   if()
      // 配置项
      const option = {
        title: {
          text: '当日各区域日耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toFixed(0).toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: dailyUsage,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toFixed(0).toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '达成率',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            markLine: {
              symbol: 'none',
              label: {
                position: 'start',
                formatter: '{c}%',
                color: '#ff0000',
                fontSize: 12,
                fontWeight: 'bold',
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: (res.averageAchieveRate * 100).toFixed(0),
                  name: '平均值',
                },
              ],
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_day2(res) {
      // 初始化图表
      console.log(res)
      let chart = echarts.init(this.$refs.chartContainer2_day)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '达成率']
      const regions = res.productPerformance.map((item) => item.productName)
      //   去年
      const dailyUsage = res.productPerformance.map((item) => item.dailyUsage)
      //   指标
      const target = res.productPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.productPerformance.map((item) => item.achievementRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: '当日各品类耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toFixed(0).toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: dailyUsage,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toFixed(0).toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '达成率',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_day3(res) {
      var res = res.subRegionPerformance
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer3_day)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '达成率']
      const categorys = res.subRegionPerformance.map((item) => item.subRegionName)
      //   指标
      const target = res.subRegionPerformance.map((item) => item.target)
      //   日耗用量
      const dailyUsage = res.subRegionPerformance.map((item) => item.dailyUsage)
      //   完成率
      const achievementRates = res.subRegionPerformance.map((item) => item.achievementRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: '当日耗用量小区排名',
          //   left: 'left',
          fontSize: 10,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: dailyUsage,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            markLine: {
              symbol: 'none',
              label: {
                position: 'start',
                formatter: '{c}',
                color: '#ff0000',
                fontSize: 12,
                fontWeight: 'bold',
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: res.averageAchieveRate.toFixed(0),
                  //   yAxis: 98,
                  name: '平均值',
                },
              ],
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '达成率',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_mtd(res) {
      var res = res.regionPerformance
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer_mtd)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const regions = res.regionPerformance.map((item) => item.region)
      //   今年
      const thisYearData = res.regionPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.regionPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.regionPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.regionPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.regionPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: 'MTD各区域耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          itemWidth: this.isMobile ? 12 : 25, // 缩小图例标记尺寸
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            markLine: {
              symbol: 'none',
              label: {
                position: 'start',
                formatter: '{c}%',
                color: '#ff0000',
                fontSize: 12,
                fontWeight: 'bold',
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: (res.averageAchieveRate * 100).toFixed(0),
                  name: '平均值',
                },
              ],
            },
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_mtd2(res) {
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer2_mtd)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const categorys = res.categoryPerformance.map((item) => item.category)
      //   今年
      const thisYearData = res.categoryPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.categoryPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.categoryPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.categoryPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.categoryPerformance.map((item) => item.growthRate * 100)
      console.log(categorys)
      console.log(thisYearData)
      console.log(target)
      console.log(achievementRates)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: 'MTD各品类耗用量达成',
          //   left: 'left',
          fontSize: 10,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          itemWidth: this.isMobile ? 12 : 25, // 缩小图例标记尺寸
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: '#051C20',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: '#00a8f3',
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: '#027ab0',
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: '#6fd2f1' },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart_mtd3(res) {
      var res = res.dailyProductPerformance
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer3_mtd)
      this.charts_list.push(chart)
      var items_color = ['#051C20', '#024c6f', '#017aaf', '#00a9f4', '#6fd2f1', '#a4ccd9', '#b3bac2']
      //   var items_color = ['#b3bac2', '#a4ccd9', '#6fd2f1', '#00a9f4', '#017aaf', '#024c6f', '#061b2c']
      const monthName = res.dailyProductPerformance.map((item) => item.date)
      const categoryValues_name = res.dailyProductPerformance[0].productPerformances.map((item) => item.productCode)
      const series = categoryValues_name.map((name, sid) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '60%',
          itemStyle: {
            color: items_color[sid],
          },
          markLine: {
            symbol: 'none',
            label: {
              position: 'start',
              formatter: '{c}',
              color: '#ff0000',
              fontSize: 12,
              fontWeight: 'bold',
              // verticalAlign: 'bottom',
            },
            lineStyle: {
              color: '#FF6B6B',
              width: 2,
            },
            data: [
              {
                yAxis: res.averageAchieveRate,
                name: '平均值',
              },
            ],
          },
          label: {
            // color: '#333',
            show: true,
            formatter: (params) => {
              if (params.value === 0) {
                return ''
              }
              return params.value.toLocaleString() // 千分位格式化
            },
            // fontWeight: 'bold',
            fontSize: 10,
          },
          data: res.dailyProductPerformance.map((d, did) => {
            return d.productPerformances[sid].total
          }),
        }
      })
      const option = {
        title: {
          text: 'MTD日耗用量趋势',
          //   left: 'left',
          fontSize: 10,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              value = p.value.toLocaleString()
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: categoryValues_name,
          itemWidth: this.isMobile ? 12 : 25, // 缩小图例标记尺寸
          //   itemWidth: 12, // 缩小图例标记尺寸
          //   itemHeight: 12,
          //   textStyle: {
          //     fontSize: 12,
          //   },
          //   selectedMode: false,
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: this.isMobile ? 50 : 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        yAxis: {
          type: 'value',
        },
        xAxis: {
          type: 'category',
          data: monthName,
        },
        series,
      }
      // 设置配置项
      chart.setOption(option, true)
    },
    initChart(res) {
      // 初始化图表
      var res = res.regionPerformance
      let chart = echarts.init(this.$refs.chartContainer)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const regions = res.regionPerformance.map((item) => item.region)
      //   今年
      const thisYearData = res.regionPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.regionPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.regionPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.regionPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.regionPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: 'YTD各区域耗用量达成',
          //   left: 'left',
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     // xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //     height: 10, // 组件高度
        //     bottom: 10,
        //   },
        //   {
        //     type: 'inside', // 内置型数据缩放
        //     zoomLock: true, // 锁定缩放比例
        //     zoomOnMouseWheel: 'shift', // 按住shift滚轮缩放
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          itemWidth: this.isMobile ? 12 : 25, // 缩小图例标记尺寸
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: regions,
            axisPointer: {
              type: 'shadow',
            },
            // axisLabel: {
            //   margin: 15, // 标签与轴线间距（默认8px）
            // },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: this.color_list[0],
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: this.color_list[1],
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: this.color_list[2],
            },
            markLine: {
              symbol: 'none',
              label: {
                position: 'start',
                formatter: '{c}%',
                color: '#ff0000',
                fontSize: 12,
                fontWeight: 'bold',
                // verticalAlign: 'bottom',
              },
              lineStyle: {
                color: '#FF6B6B',
                width: 2,
              },
              data: [
                {
                  yAxis: (res.averageAchieveRate * 100).toFixed(0),
                  name: '平均值',
                },
              ],
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: this.color_list[3] },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart2(res) {
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer2)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const categorys = res.categoryPerformance.map((item) => item.category)
      //   今年
      const thisYearData = res.categoryPerformance.map((item) => item.thisYear)
      //   去年
      const lastYearData = res.categoryPerformance.map((item) => item.lastYear)
      //   指标
      const target = res.categoryPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.categoryPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.categoryPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: 'YTD各品类耗用量达成',
          //   left: 'left',
          fontSize: 10,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          itemWidth: this.isMobile ? 12 : 25, // 缩小图例标记尺寸
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: this.color_list[0],
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: this.color_list[1],
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: this.color_list[2],
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: this.color_list[3] },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart3(res) {
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer3)
      this.charts_list.push(chart)
      const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      const categorys = res.monthlyPerformance.map((item) => item.monthName)
      //   今年
      const thisYearData = res.monthlyPerformance.map((item) => item.thisMonth)
      //   去年
      const lastYearData = res.monthlyPerformance.map((item) => item.lastMonth)
      //   指标
      const target = res.monthlyPerformance.map((item) => item.target)
      //   完成率
      const achievementRates = res.monthlyPerformance.map((item) => item.achievementRate * 100)
      //   增长率
      const growthRates = res.monthlyPerformance.map((item) => item.growthRate * 100)
      //   设置series
      let series_list = legends.map((name) => {
        console.log(name)
        // return {
        //   name: name,
        //   type: 'bar',
        //   itemStyle: itemStyle_cls,
        //   data: res.map((d, did) => {
        //     return d.data[sid].accuracyPercentage
        //   }),
        // }
      })
      // 配置项
      const option = {
        title: {
          text: 'YTD各月耗用量达成',
          //   left: 'left',
          fontSize: 10,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0],
        //     start: 0,
        //     end: 100,
        //   },
        // ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              if (p.seriesType === 'line') {
                value = `${p.value.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`
              } else {
                value = p.value.toLocaleString()
              }
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: legends, // 新增图例项
          itemWidth: this.isMobile ? 12 : 25, // 缩小图例标记尺寸
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categorys,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 200,
            // axisLabel: {
            //   formatter: '{value} 件',
            // },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // max: 100,
            axisLabel: {
              formatter: '{value} %',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '指标',
            type: 'bar',
            data: target,
            itemStyle: {
              color: this.color_list[0],
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return params.value.toLocaleString()
              },
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量',
            type: 'bar',
            data: thisYearData,
            itemStyle: {
              color: this.color_list[1],
            },
            barWidth: '30%',
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value.toLocaleString(), // 千分位格式化
              color: '#333',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量达成',
            type: 'line',
            yAxisIndex: 1,
            data: achievementRates,
            itemStyle: {
              color: this.color_list[2],
            },
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              type: 'dashed',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => {
                return `${params.value.toLocaleString()}%`
              },
              //   color: '#00a9f4',
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
          {
            name: '日耗用量增长',
            type: 'line',
            yAxisIndex: 1,
            data: growthRates,
            itemStyle: { color: this.color_list[3] },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3,
              type: 'dashed', // 使用虚线区分
            },
            label: {
              show: true,
              //   position: 'bottom',
              formatter: (params) => {
                const value = params.value.toLocaleString()
                return `${value}%`
              },
              //   color: (params) => (params.value > 0 ? '#67c23a' : '#f56c6c'),
              fontWeight: 'bold',
              fontSize: 10,
            },
          },
        ],
      }

      // 设置配置项
      chart.setOption(option, true)
    },
    initChart4(res) {
      // 初始化图表
      let chart = echarts.init(this.$refs.chartContainer4)
      this.charts_list.push(chart)
      //   const legends = ['指标', '日耗用量', '日耗用量达成', '日耗用量增长']
      var items_color = this.color_list2
      //   var items_color = ['#b3bac2', '#a4ccd9', '#6fd2f1', '#00a9f4', '#017aaf', '#024c6f', '#051C20']
      const monthName = res.monthlyCategoryTrend.map((item) => item.monthName)
      const categoryValues_name = res.monthlyCategoryTrend[0].categoryValues.map((item) => item.name)
      console.log(categoryValues_name)
      const series = categoryValues_name.map((name, sid) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '60%',
          itemStyle: {
            color: items_color[sid],
          },
          label: {
            // color: '#333',
            show: true,
            formatter: (params) => {
              if (params.value === 0) {
                return ''
              }
              return params.value.toLocaleString() // 千分位格式化
            },
            // fontWeight: 'bold',
            fontSize: 10,
          },
          data: res.monthlyCategoryTrend.map((d, did) => {
            return d.categoryValues[sid].value
          }),
        }
      })
      const option = {
        title: {
          text: 'YTD日耗用量趋势',
          //   left: 'left',
          fontSize: 10,
          textStyle: {
            fontSize: window.innerWidth > 768 ? 16 : 14, // 桌面端16px，移动端14px
          },
          top: 5,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' },
          formatter: (params) => {
            let res = `${params[0].name}<br>`
            params.forEach((p) => {
              let value
              value = p.value.toLocaleString()
              res += `${p.marker} ${p.seriesName}: ${value}<br>`
            })
            return res
          },
        },
        legend: {
          data: categoryValues_name,
          itemWidth: 12, // 缩小图例标记尺寸
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
          },
          left: 0,
          //   selectedMode: false,
          bottom: 0,
        },
        grid: {
          top: 50, // 图表主体在标题+图例下方
          bottom: this.isMobile ? 50 : 30,
          left: 10,
          right: 20,
          containLabel: true,
        },
        yAxis: {
          type: 'value',
        },
        xAxis: {
          type: 'category',
          data: monthName,
        },
        series,
      }
      // 设置配置项
      chart.setOption(option, true)
    },
    // 防抖动
    debounce(fn, delay) {
      let timer = null
      return function (...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(this, args)
        }, delay)
      }
    },
    // 响应视觉窗口变化调整图表大小
    resizeHandler() {
      let resizeHandler = this.debounce(() => {
        this.charts_list.forEach((chart) => {
          //   console.log(chart)
          chart.resize()
        })
      }, 300)
      window.addEventListener('resize', resizeHandler)
    },
    // 销毁图表实例
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeHandler)
      this.charts_list.forEach((chart) => chart.dispose())
    },
    // handleResize() {
    //   this.chart && this.chart.resize()
    // },
    async system_getproductlistothers_fn() {
      const { data } = await system_getproductlistothers()
      this.product_List = data.data
    },
    getReportData(res) {
      console.log(this.area_list)
      if (this.area_list.length == 1) {
        console.log(this.area_list)
      }
      var un = Number(this.activeName)
      switch (un) {
        case 1:
          this.filters = res
          this.usagereport_getytdusage_ytd_fn()
          break
        case 2:
          this.filters_mtd = res
          console.log(this.filters_mtd)
          this.usagereport_getytdusage_mtd_fn()
          break
        case 3:
          this.filters_day = res
          this.usagereport_getdailyusage_day_fn()
          break
      }
    },
    handleClick(tab, event) {
      this.beforeDestroy()
      //   var name = tab.name
      //   switch (name) {
      //     case '1':
      //       this.usagereport_getytdusage_ytd_fn()
      //       break
      //     case '2':
      //       this.usagereport_getytdusage_mtd_fn()
      //       break
      //     case '3':
      //       this.usagereport_getdailyusage_day_fn()
      //       break
      //   }
    },
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandler())
    // this.filters.StartMonth = '2025-01'
    // this.filters.EndMonth = calculateSum()
    // this.filters_mtd.Month = calculateSum(7)
    // this.filters_day.Date = calculateSum(1)
    // this.filters_day.Date = '2025-03-18'
    // this.usagereport_getytdusage_ytd_fn()
    this.dashboard_getregionsbylevel()
    this.extapi_dashboard_get_fn()
    this.system_getproductlistothers_fn()
    // this.usagereport_getdailyusage_day_fn()
    this.isMobile = window.innerWidth <= 475
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
  },
}
</script>
<style>
.card_cls .el-card__body {
  padding: 5px !important;
}
.card_cls_mb {
  margin-bottom: 5px;
}
.card_cls div {
  text-align: center;
}
.el-tabs__item {
  font-size: 13px !important;
}
.el-tabs__header {
  margin: 0 0 5px !important;
}
.reports .cell {
  padding: 0 !important;
  font-size: 12px;
}
.reports td.el-table__cell {
  padding: 0 !important;
}
</style>
